import UAParser from "ua-parser-js";

export const getDeviceInfo = (() => {
  const parser = new UAParser();
  const cachedDeviceInfo = parser.getResult(); // Cache the result immediately

  return () => cachedDeviceInfo; // Return a function that provides access to the cached result
})();
